import I18n from '../i18n';
import history from 'src/routes/history';

/* eslint-disable no-console */
const graphqlError = (error) => {
  const errorCode = error.graphQLErrors[0].extensions.code;

  if (errorCode === 'BAD_USER_INPUT') {
    // nunca deberia pasar, es que no esta actualizada las validaciones en el frontend, esto lo manda el yoi
    const errors = error.graphQLErrors[0].extensions.details;
    const parsedErrors = errors.map((error_) => error_.message);
    return parsedErrors;
  }

  // esto se deberia mostrar al usuario
  if (errorCode === 'HANDLED_ERROR') {
    return error.graphQLErrors[0].message;
  }

  // te rechaza el passport y eso, agarrar y mandarlo al login
  if (errorCode === 'UNAUTHENTICATED') {
    if (import.meta.env.VITE_APP_DEBUG === 'true') {
      console.log(error.graphQLErrors[0].message);
    }

    return I18n.t('GENERAL_ERROR');
  }

  if (import.meta.env.VITE_APP_DEBUG === 'true') {
    console.log(error.graphQLErrors[0].message);
  }

  return I18n.t('GENERAL_ERROR');
};

const errorHandler = (error) => {
  if (error.message.includes('GraphQL')) {
    return graphqlError(error);
  }

  if (
    error.message.includes('Network error') ||
    error.message.includes('Failed to fetch')
  ) {
    return I18n.t('NETWORK_ERROR');
  }

  if (error.message.toLowerCase().includes('no session')) {
    history.push('/logout');
  }

  return error.message;
};

export default errorHandler;
